module.exports = __webpack_public_path__ + "static/media/OW3.55d89b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW3.png
// module id = 720
// module chunks = 0